import { ConsumerState } from "../ConsumerInfo";
const GOOD_STATES = [
    ConsumerState.Connected,
    ConsumerState.ProducerDisconnected,
];
const getInitialStateTimes = () => ({
    [ConsumerState.WaitingForSFUAddress]: {
        start: 0,
        end: 0,
    },
    [ConsumerState.ConnectingToSFU]: {
        start: 0,
        end: 0,
    },
    [ConsumerState.NotAllowed]: {
        start: 0,
        end: 0,
    },
    [ConsumerState.Connected]: {
        start: 0,
        end: 0,
    },
    [ConsumerState.Consuming]: {
        start: 0,
        end: 0,
    },
    [ConsumerState.ProducerDisconnected]: {
        start: 0,
        end: 0,
    },
});
export class ConsumerStateWrapper {
    _state;
    _badStateTimer;
    _maxTimeToGoodStateMS;
    _overAllowed;
    _onOverAllowed;
    _onBadStateTimeout;
    _onRecovery;
    _hasBadStateTriggered = false;
    stateTimes = getInitialStateTimes();
    constructor(initialState, overAllowed, maxTimeToGoodStateMS, onBadStateTimeout, onRecovery, onOverAllowed) {
        this._state = initialState;
        this._overAllowed = overAllowed;
        this._maxTimeToGoodStateMS = maxTimeToGoodStateMS;
        this._onBadStateTimeout = () => {
            this._clearBadStateTimer();
            this._hasBadStateTriggered = true;
            this.stateTimes[this._state].end = Date.now();
            onBadStateTimeout(this._overAllowed, this.getStateTimeSummary());
        };
        this._onOverAllowed = onOverAllowed;
        if (!GOOD_STATES.includes(this._state)) {
            this._startBadStateTimer();
        }
        if (this._overAllowed) {
            this._onOverAllowed();
        }
        this._onRecovery = onRecovery;
    }
    setOverAllowed(over) {
        if (over && !this._overAllowed) {
            this._onOverAllowed();
        }
        this._overAllowed = over;
    }
    setState(newState) {
        if (this._state === newState)
            return;
        this.stateTimes[this._state].end = Date.now();
        this.stateTimes[newState].start = Date.now();
        this._state = newState;
        const isStateGood = GOOD_STATES.includes(this._state);
        if (isStateGood) {
            if (this._badStateTimer !== undefined) {
                this._clearBadStateTimer();
            }
            if (this._hasBadStateTriggered) {
                this._onRecovery();
                this._hasBadStateTriggered = false;
            }
        }
        else if (!isStateGood && this._badStateTimer === undefined) {
            this._startBadStateTimer();
        }
    }
    destroy() {
        this._clearBadStateTimer();
    }
    getStateTimeSummary() {
        return Object.entries(this.stateTimes).reduce((result, [state, times]) => {
            const sanitizedState = state.toLowerCase().replaceAll(" ", "-");
            return {
                ...result,
                [`time-in-state-${sanitizedState}`]: times.end - times.start,
            };
        }, {});
    }
    _startBadStateTimer() {
        if (this._badStateTimer !== undefined)
            return;
        this.stateTimes = getInitialStateTimes();
        this.stateTimes[this._state].start = Date.now();
        this._badStateTimer = window.setTimeout(this._onBadStateTimeout, this._maxTimeToGoodStateMS);
    }
    _clearBadStateTimer() {
        window.clearTimeout(this._badStateTimer);
        delete this._badStateTimer;
    }
}
//# sourceMappingURL=ConsumerStateWrapper.js.map